import { get } from 'lodash-es';

export const ERROR = Symbol('ERROR');

export const errorHandleAction = (message, status, type) => {
  let msg = typeof message === 'string' ? message : get(message, 'stack', 'unknown error');

  return {
    type: ERROR,
    payload: { message: msg, status, type },
  };
};
